import "./App.css";
import { Fragment, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import FormPage from "./pages/FormPage";
import EventsPage from "./pages/EventsPage";
import AttendeesPage from "./pages/AttendeesPage";
import useAuthState from "./hooks/authHooks";
import Login from "./pages/auth/Login";

function App() {
  const { loadUser, auth } = useAuthState();

  useEffect(() => {
    loadUser();
  }, [auth.isAuthenticated]);

  return (
    <Fragment>
      <Routes>
        <Route path="/form/:referal" element={<FormPage />} />
        <Route path="/form" element={<FormPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/attendees/:event" element={<AttendeesPage />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </Fragment>
  );
}

export default App;
